/**
 * 「现在能不能取餐」这条判断（纯函数，可单元测试）。
 *
 * ============================================================
 * 为什么值得单独抽出来测
 * ============================================================
 * 现场出现过这个事：**顾客付完钱就把餐领走了**，而厨房那时还没开始做。
 * 根因之一是文案在帮倒忙 —— 页面写着「请到取餐口取餐」，等于主动叫他去拿。
 *
 * 所以这条规则必须钉死：
 *   · 付完款的那一刻状态是 **已接单（ACCEPTED）**，不是「待取餐」→ **还不能取**；
 *   · 只有厨房点了「出餐」之后变成 **待取餐（READY）** → 才叫「可以取了」；
 *   · 「正在做」和「还没开始做」要分开说，否则顾客会以为马上就好。
 *
 * 触屏机的取餐号页、电子小票页共用这一份判断，避免两处文案各说一套。
 */
import { OrderStatus } from '@jinhua/shared';

export type PickupTone = 'ok' | 'wait' | 'muted' | 'danger';

export interface PickupState {
  tone: PickupTone;
  /** 大字结论：能不能取 */
  title: string;
  /** 一句解释 */
  note: string;
  /** 严格意义上的「可以取餐」 */
  canPickup: boolean;
}

export function pickupStateFor(status: string | null | undefined): PickupState {
  switch (status) {
    case OrderStatus.READY:
      return {
        tone: 'ok',
        title: '可以取了',
        note: '请把这个取餐号给取餐口的店员看',
        canPickup: true,
      };
    case OrderStatus.COMPLETED:
      return {
        tone: 'muted',
        title: '这一单已完成',
        note: '如果还没拿到餐，请找店员',
        canPickup: false,
      };
    case OrderStatus.CANCELLED:
      return {
        tone: 'danger',
        title: '这一单已取消',
        note: '请找店员处理',
        canPickup: false,
      };
    case OrderStatus.COOKING:
      return {
        tone: 'wait',
        title: '正在做，请稍等',
        note: '做好后这一页会变成「可以取了」',
        canPickup: false,
      };
    default:
      // PENDING（待接单）/ ACCEPTED（已接单，触屏机付完款就是这个状态）/ 未知
      return {
        tone: 'wait',
        title: '还没开始做，请稍等',
        note: '做好后这一页会变成「可以取了」',
        canPickup: false,
      };
  }
}
